import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Motivation = lazyWithPreload(() => import('./Motivation'))
export const LikeChatMotivation = lazyWithPreload(
  () => import('./LikeChatMotivation'),
)
